import React from 'react';
import CustomText from '../../../../Typography/CustomText/CustomText';

interface SiteKitSignPostTitleProps {
  children: React.ReactNode;
  hasSubtitle: boolean;
}
const SiteKitSignPostTitle = ({ children, hasSubtitle }: SiteKitSignPostTitleProps) => (
  <CustomText as="span" color="black" whiteSpace="nowrap" size={hasSubtitle ? 'xlarge' : '20'} weight="medium">
    {children}
  </CustomText>
);

SiteKitSignPostTitle.displayName = 'SiteKit.Header.SignPost.Title';

export { SiteKitSignPostTitle, SiteKitSignPostTitleProps };
